/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  useEffect,
  useRef,
  useState,
} from 'react';

import _ from "lodash";
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import SVG from 'react-inlinesvg';
import {
  toAbsoluteUrl,
} from '../../../_metronic/helpers';

import LoadingContent from '../../modules/loading/LoadingContent';
import { ListBranchCoupons } from '../Coupon/ListBranchCoupons';
import PaymentPage from '../Payment/PaymentPage';

import {
  parseWeekDays,
} from '../../services/dates';

import {
  formatMoney,
} from '../../services/intFormat';

import {
  fetchBranchCoupons,
} from '../../services/coupons';

import { fetchSignaturePlans } from 'app/services/signatures';

import {
  trackViewItem,
  buildEcommerceParams,
} from '../../services/analytics';

const CreateSignature = ({branch, type}) => {
  const { packages, auth, coupons } = useSelector((state : any) => ({
    packages: state.packages,
    auth: state.auth,
    coupons: state.coupons,
  }), shallowEqual);

  const location :any = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const timeRef = useRef<any>();
  const goToCheckoutRef = useRef<any>();

  const [packagesListed, setPackagesListed] = useState<any>([]);
  const [selectedPackage, setSelectedPackage] = useState<any>({});
  const [selectedPrice, setSelectedPrice] = useState<any>({});

  const [selectedCoupon, setSelectedCoupon] = useState<any>({});
  const [openPayment, setOpenPayment] = useState<any>(false);
  const [openListBranchCoupons, setOpenListBranchCoupons] = useState<any>(false);
  const [showRules, setShowRules] = useState<boolean>(false);

  useEffect(() => {
    console.log(branch?.attributes?.partner_id);
    if(branch?.attributes?.partner_id) {
      dispatch<any>(fetchSignaturePlans(branch?.attributes?.partner_id, selectedCoupon.id)).then((data: any) => {
        setPackagesListed(data);
        // changePackage(data[0]);
      });
    }
  }, [branch]);

  const selectCoupon = (value: any) => {
    setSelectedCoupon(value);
    setShowRules(false);

    // fetchPackages(branch.attributes.partner_id, type, modality, value.id).then((value) => {
    //   setPackages(value);

    //   reloadServicePriceByCoupon(value);
    // });

    dispatch<any>(fetchSignaturePlans(branch?.attributes?.partner_id, value.id)).then((data: any) => {
      setPackagesListed(data);

      reloadServicePriceByCoupon(data);
    });
  }

  const reloadServicePriceByCoupon = (data: any) => {
    data.map((value: any) => {
      if (value.id === selectedPackage.id) {
        changePackage(value, false);
      }
    });
  }

  const navigateToLogin = () => {
    navigate({}, { state: { login: location } })
  }

  const nextStep = () => {
    if (!auth.user) {
      navigateToLogin();
      return
    }

    if (auth.user && !auth.user?.phone) {
      navigate({}, { state: { verifyPhoneUrl: location } });
      return
    }

    setOpenPayment(true);
  }

  const parseValue = (value, type) => {
    let message = 'R$ ' + value;

    if (type === 'percentage') {
      message = value + '% na compra';
    }

    return message;
  }

  const changePackage = (value: any, trackView = true) => {
    setSelectedPackage(value);

    let priceData;

    if (type === 'plan') {
      priceData = {
        total_price: value?.relationships?.origin?.attributes?.price,
        price: value?.relationships?.origin?.attributes?.price,
        amount: 1,
        expired: 30
      };
    } else {
      priceData = value?.attributes?.prices[0];
    }

    setSelectedPrice(priceData);

    if (trackView) {
      trackViewItem(buildEcommerceParams({
        id: value.id,
        name: value?.attributes?.name,
        price: priceData?.price ?? 0,
        itemBrand: branch?.attributes?.name,
        itemVariant: 'recurrence',
        coupon: selectedCoupon?.id && !value?.attributes?.coupon_disabled ? selectedCoupon : null,
        purchaseType: 'signature',
      }));
    }

    setTimeout(() => {
      if (timeRef && timeRef.current && timeRef.current.offsetTop) {
        timeRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 100)
  }

  useEffect(() => {
    if (branch?.id && auth?.user?.id) {
      dispatch<any>(fetchBranchCoupons(branch?.attributes?.partner_id, 'single', 'signature'));
    }
  }, [branch, auth?.user?.id]);

  return (
    <>
      <div className="flex-column-fluid">
        <div className="d-flex flex-column flex-lg-row min-h-500px">
          <div className="flex-lg-row-fluid mb-10 mb-lg-0">
            <div className="bg-body flex-lg-row-fluid flex-center rounded-4 p-10 h-100">
              <div className="mb-13 text-center">
                <h1 className="mb-3">
                  Clubinho
                </h1>
                <div className="text-muted fw-semibold fs-5">
                  Adquira sua assinatura e jogue sempre!
                </div>
              </div>

              <div className="d-flex flex-column">
                {packages.listLoading && <LoadingContent />}

                {!packages.listLoading && <div className="row">
                  <div className="col-lg-12 mb-10 mb-lg-0">
                    {packagesListed && packagesListed.map(plan => <label
                      className={`btn btn-outline btn-active-light-primary d-flex flex-stack text-start p-6 mb-5 ${selectedPackage?.id && plan.id === selectedPackage.id ? 'btn-outline-primary active' : 'btn-outline-dashed'}`}
                      onClick={() => changePackage(plan)}
                    >
                      <div className="d-flex align-items-center me-2">
                        {/* <div className={`form-check form-check-custom form-check-primary-reverse form-check-success flex-shrink-0 me-6 ${(selectedPackage?.id && plan.id === selectedPackage.id) ? 'form-check-primary-reverse' : 'form-check-solid'}`}>
                          <input className="form-check-input" type="radio" checked={selectedPackage?.id && plan.id === selectedPackage.id} />
                        </div> */}
                        <div className="flex-grow-1">
                          <span>
                              <h4 className="text-gray-900 fw-bold cursor-pointer mb-0">
                                {plan?.attributes.name}
                              </h4>
                              <div className="text-gray-700 fw-semibold cursor-pointer fs-5">
                                {plan?.attributes.description}
                              </div>
                          </span>
                        </div>
                      </div>
                      <div className="ms-5">
                        {plan.attributes.total_price && plan.attributes.total_price !== plan.attributes.price && <span className="lineThrough fs-7 text-gray-600 mx-3">
                          {formatMoney(plan.attributes.total_price)}
                        </span>}

                        <span className="mb-2">R$</span>
                        <span className="fs-3x fw-bold">
                          {plan.attributes.price && formatMoney(plan?.attributes.price, false, false)}
                        </span>
                        <span className="fs-8 text-gray-700">
                          {plan?.attributes?.duration > 1 ? `/${plan?.attributes?.duration} meses` : `/mês`}
                        </span>
                      </div>
                    </label>)}

                    {packagesListed.length === 0 && <div className="mb-13 text-center">
                      <h2 className="my-3 text-gray-800">
                        Ops, nenhum pacote disponível!
                      </h2>
                      <div className="text-gray-500 fw-semibold fs-5">
                        Quando a arena disponibilizar novos assinaturas, elas aparecerão aqui
                      </div>
                    </div>}
                  </div>
                </div>}
              </div>
            </div>
          </div>
          {selectedPackage?.id && <div className="flex-lg-auto min-w-lg-400px ms-lg-10">
            <div
              className="card card-flush pt-3 mb-0 position-sticky top-7"
              ref={timeRef}
            >
                <div className="card-body pt-3 fs-6">
                  {<>
                    <div className="mb-5">
                      <h1 className="mb-3 text-center">
                        Cupom de desconto
                      </h1>
                      <div className="text-muted fw-semibold fs-5 text-center">
                        Veja os cupons disponíveis para o horário selecionado e aproveite
                      </div>

                      <div className="d-flex justify-content-center">
                        <div
                          className={`
                            card card-dashed flex-row flex-wrap py-5 my-5 cursor-pointer mw-400px w-100 ${selectedCoupon.id && selectedPackage.attributes.coupon_disabled && `border-warning border border-dashed`}`}
                          onClick={() => auth.user ? setOpenListBranchCoupons(true) : navigateToLogin()}
                        >
                          {/*<img src={toAbsoluteUrl(`/media/custom/coupons.png`)} width="40" height="40" className="mx-5 align-self-center" />*/}
                          <SVG src={toAbsoluteUrl('/media/svg/custom/coupons.svg')} width="40" height="40" className="mx-5 align-self-center text-white" fill="white" />
                          <div className="d-flex flex-column pe-7">
                              <div className="d-flex align-items-center fs-4 fw-bold mb-1">
                                {!selectedCoupon.id && `Cupom de desconto`}
                                {selectedCoupon.id && selectedCoupon.attributes.name}
                              </div>
                              <div className="d-flex align-items-center fs-5 fw-semibold text-gray-600">
                                {selectedCoupon.id && <>
                                  {selectedPackage.attributes.coupon_disabled && 'Cupom não aplicado'}
                                  {!selectedPackage.attributes.coupon_disabled && 'Cupom aplicado'}
                                </>}

                                {!selectedCoupon.id && <>
                                  {!selectedCoupon.id && coupons?.entities?.length > 0 ?
                                    `${coupons.entities.length} ${coupons.entities.length === 1 ? "disponível" : "disponíveis"}`
                                    : auth.user ? `Nenhum disponível` : `Fazer login`}
                                </>}
                              </div>
                              <i className="position-absolute end-0 mt-5 me-5 las la-angle-right fs-2x text-white"></i>
                          </div>
                        </div>
                      </div>

                      {selectedCoupon && selectedCoupon.id && <>
                        <span
                          className="cursor-pointer text-primary fs-6"
                          onClick={() => setShowRules(!showRules)}
                        >
                          {showRules ? "Ocultar regras" : "Ver regras"}
                        </span>

                        {showRules && <div className="pt-3">
                          {selectedCoupon?.attributes?.weekdays?.length > 0 && <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">
                            • Válido de {parseWeekDays(selectedCoupon.attributes.weekdays)}
                          </div>}
                          {selectedCoupon?.attributes?.start_at && selectedCoupon?.attributes?.end_at && <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">
                            • Entre os horários das {selectedCoupon.attributes.start_at} até {selectedCoupon.attributes.end_at}
                          </div>}
                          <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">
                            • Desconto de {selectedCoupon && selectedCoupon.attributes && parseValue(selectedCoupon.attributes.value, selectedCoupon.attributes.type)}
                          </div>
                          {selectedCoupon.relationships?.coupon_restrictions?.length > 0 && <div className="d-flex align-items-center fs-6 fw-semibold text-gray-600">
                            • Válido para {_.map(selectedCoupon.relationships.coupon_restrictions,'relationships.origin.attributes.name').join(",")}
                          </div>}
                        </div>}
                      </>}
                    </div>
                  </>}

                  <div className="mb-5">
                    <div className="fw-semibold fs-2 text-center mb-3">
                      Regras de utilização
                    </div>

                    <div className="text-gray-800 fs-6">
                      • Válido {selectedPackage?.attributes?.weekdays && parseWeekDays(selectedPackage.attributes.weekdays)}
                    </div>

                    <div className="text-gray-800 fs-6">
                      • Duração de {selectedPackage?.attributes?.duration > 1 ? `${selectedPackage?.attributes?.duration} meses` : `1 mês`}
                    </div>

                    <div className="text-gray-800 fs-6">
                      • Não pode ser transferido para outro jogador
                    </div>

                    <div className="text-gray-800 fs-6">
                      • Preço válido para compras realizadas no app
                    </div>
                  </div>

                  {selectedCoupon?.id && selectedPackage?.attributes?.coupon_disabled && <div
                    className={`
                      justify-content-center card card-dashed flex-row flex-wrap p-5 my-5 cursor-pointer w-100 ${`border-warning border border-dashed`}`}
                  >
                    <span className="text-white">Cupom não aplicado</span>
                  </div>}
                  <div className="mb-0" ref={goToCheckoutRef}>
                    <button
                      className="btn btn-primary btn-lg cursor-pointer fw-bold w-100 mt-4"
                      disabled={!selectedPackage?.id && selectedPrice?.amount > 0}
                      onClick={() => nextStep()}
                    >
                      IR PARA PAGAMENTO
                    </button>
                  </div>
                </div>
              </div>
          </div>}
        </div>
      </div>

      <ListBranchCoupons
        isOpen={openListBranchCoupons}
        onClosed={() => setOpenListBranchCoupons(false)}
        onSelect={value => selectCoupon(value)}
        selectedCoupon={selectedCoupon.id}
        branchId={branch?.attributes?.partner_id}
        date={''}
        sellingType="single"
        sellingModality="signature"
      />

      <PaymentPage
        isOpen={openPayment}
        onClosed={() => setOpenPayment(false)}
        attributes={{
          type: 'signature',
          modality: 'single',
          service: {
            id: selectedPackage?.id,
            name: selectedPackage?.attributes?.name,
            price_total: selectedPackage?.attributes?.total_price,
            price: selectedPackage?.attributes?.price,
          },
          branch: branch,
          item_variant: 'recurrence',
          duration: selectedPackage?.attributes?.duration,
          coupon: !selectedPackage?.attributes?.coupon_disabled ? selectedCoupon : null,
        }}
      />
    </>
  )
}

export default CreateSignature;
